import React from 'react';

const frame = {
  width: 48,
  height: 30,
  viewBox: '0 0 48 30',
  rx: 5,
  stroke: '#E5E9E9',
};

/** Visa */
export const VisaIcon = () => (
  <svg
    width={frame.width}
    height={frame.height}
    viewBox={frame.viewBox}
    aria-hidden
    focusable="false"
  >
    <title>Visa</title>
    <rect
      width="48"
      height="30"
      rx={frame.rx}
      fill="#0E4595"
      stroke={frame.stroke}
      strokeWidth="1"
    />
    <text
      x="24"
      y="19"
      textAnchor="middle"
      fill="#fff"
      fontSize="11"
      fontWeight="800"
      fontFamily="system-ui, -apple-system, sans-serif"
      letterSpacing="0.14em"
    >
      VISA
    </text>
  </svg>
);

/** Mastercard */
export const MastercardIcon = () => (
  <svg
    width={frame.width}
    height={frame.height}
    viewBox={frame.viewBox}
    aria-hidden
    focusable="false"
  >
    <title>Mastercard</title>
    <rect
      width="48"
      height="30"
      rx={frame.rx}
      fill="#fff"
      stroke={frame.stroke}
      strokeWidth="1"
    />
    <circle cx="20" cy="15" r="8" fill="#EB001B" />
    <circle cx="28" cy="15" r="8" fill="#F79E1B" fillOpacity="0.95" />
    <path
      d="M24 10c1.6 1 2.5 2.6 2.5 5s-.9 4-2.5 5c-1.6-1-2.5-2.6-2.5-5s.9-4 2.5-5z"
      fill="#FF5F00"
    />
  </svg>
);

/** PayPal */
export const PayPalIcon = () => (
  <svg
    width={frame.width}
    height={frame.height}
    viewBox={frame.viewBox}
    aria-hidden
    focusable="false"
  >
    <title>PayPal</title>
    <rect
      width="48"
      height="30"
      rx={frame.rx}
      fill="#003087"
      stroke={frame.stroke}
      strokeWidth="1"
    />
    <text
      x="24"
      y="19"
      textAnchor="middle"
      fill="#fff"
      fontSize="8.5"
      fontWeight="800"
      fontFamily="system-ui, sans-serif"
      letterSpacing="0.02em"
    >
      PayPal
    </text>
  </svg>
);

/** SEPA - bank debit, DE / AT / EU */
export const SepaIcon = () => (
  <svg
    width={frame.width}
    height={frame.height}
    viewBox={frame.viewBox}
    aria-hidden
    focusable="false"
  >
    <title>SEPA</title>
    <rect
      width="48"
      height="30"
      rx={frame.rx}
      fill="#fff"
      stroke="#1B3B6F"
      strokeWidth="1.5"
    />
    <text
      x="24"
      y="19"
      textAnchor="middle"
      fill="#1B3B6F"
      fontSize="10"
      fontWeight="800"
      fontFamily="system-ui, -apple-system, sans-serif"
      letterSpacing="0.1em"
    >
      SEPA
    </text>
  </svg>
);

/** Stripe - payments platform */
export const StripeIcon = () => (
  <svg
    width={52}
    height={frame.height}
    viewBox="0 0 52 30"
    aria-hidden
    focusable="false"
  >
    <title>Stripe</title>
    <rect
      width="52"
      height="30"
      rx={frame.rx}
      fill="#fff"
      stroke={frame.stroke}
      strokeWidth="1"
    />
    <text
      x="26"
      y="19"
      textAnchor="middle"
      fill="#635BFF"
      fontSize="12"
      fontWeight="700"
      fontFamily="system-ui, -apple-system, BlinkMacSystemFont, sans-serif"
      letterSpacing="-0.02em"
    >
      stripe
    </text>
  </svg>
);

/** Official Stripe wordmark (Stripe, Inc. logo, revised 2016). Pair with “Powered by” text. */
export const StripeWordmark = ({ height = 18 }: { height?: number }) => {
  const w = (height * 360.02) / 149.84;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="54 36 360.02 149.84"
      width={w}
      height={height}
      role="img"
      aria-label="Stripe"
      style={{ flexShrink: 0, display: 'block' }}
    >
      <g fill="#635BFF" fillRule="evenodd" clipRule="evenodd">
        <path d="M414,113.4c0-25.6-12.4-45.8-36.1-45.8c-23.8,0-38.2,20.2-38.2,45.6c0,30.1,17,45.3,41.4,45.3c11.9,0,20.9-2.7,27.7-6.5v-20c-6.8,3.4-14.6,5.5-24.5,5.5c-9.7,0-18.3-3.4-19.4-15.2h48.9C413.8,121,414,115.8,414,113.4z M364.6,103.9c0-11.3,6.9-16,13.2-16c6.1,0,12.6,4.7,12.6,16H364.6z" />
        <path d="M301.1,67.6c-9.8,0-16.1,4.6-19.6,7.8l-1.3-6.2h-22v116.6l25-5.3l0.1-28.3c3.6,2.6,8.9,6.3,17.7,6.3c17.9,0,34.2-14.4,34.2-46.1C335.1,83.4,318.6,67.6,301.1,67.6z M295.1,136.5c-5.9,0-9.4-2.1-11.8-4.7l-0.1-37.1c2.6-2.9,6.2-4.9,11.9-4.9c9.1,0,15.4,10.2,15.4,23.3C310.5,126.5,304.3,136.5,295.1,136.5z" />
        <polygon points="223.8,61.7 248.9,56.3 248.9,36 223.8,41.3" />
        <rect x="223.8" y="69.3" width="25.1" height="87.5" />
        <path d="M196.9,76.7l-1.6-7.4h-21.6v87.5h25V97.5c5.9-7.7,15.9-6.3,19-5.2v-23C214.5,68.1,202.8,65.9,196.9,76.7z" />
        <path d="M146.9,47.6l-24.4,5.2l-0.1,80.1c0,14.8,11.1,25.7,25.9,25.7c8.2,0,14.2-1.5,17.5-3.3V135c-3.2,1.3-19,5.9-19-8.9V90.6h19V69.3h-19L146.9,47.6z" />
        <path d="M79.3,94.7c0-3.9,3.2-5.4,8.5-5.4c7.6,0,17.2,2.3,24.8,6.4V72.2c-8.3-3.3-16.5-4.6-24.8-4.6C67.5,67.6,54,78.2,54,95.9c0,27.6,38,23.2,38,35.1c0,4.6-4,6.1-9.6,6.1c-8.3,0-18.9-3.4-27.3-8v23.8c9.3,4,18.7,5.7,27.3,5.7c20.8,0,35.1-10.3,35.1-28.2C117.4,100.6,79.3,105.9,79.3,94.7z" />
      </g>
    </svg>
  );
};

/** Decorative invoice illustration (compact) */
export const InvoiceDocIcon = () => (
  <svg
    width="100%"
    height="26"
    viewBox="0 0 200 40"
    preserveAspectRatio="xMidYMid meet"
    aria-hidden
    focusable="false"
  >
    <title>Invoice</title>
    <rect
      x="76"
      y="4"
      width="48"
      height="32"
      rx="5"
      fill="#F6FBFA"
      stroke="#C9D9E2"
      strokeWidth="1.5"
    />
    <line
      x1="86"
      y1="13"
      x2="114"
      y2="13"
      stroke="#8298AB"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <line
      x1="86"
      y1="18"
      x2="110"
      y2="18"
      stroke="#8298AB"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <line
      x1="86"
      y1="23"
      x2="106"
      y2="23"
      stroke="#8298AB"
      strokeWidth="1"
      strokeLinecap="round"
    />
    <circle cx="100" cy="28" r="3.5" fill="#33ABA7" opacity="0.35" />
  </svg>
);
